import React, { useState, useDebugValue } from 'react'

export function DefaultContext(){
    const [display, setDisplay] = useState(null)
    return {display, setDisplay}
}

const PopupContext = React.createContext(DefaultContext);
export default PopupContext;